export default __webpack_public_path__ + "static/media/1617 knife block A side.922ca4f9.png";